const actionTypes = {
    GET_MATCHING_RULE_NAMES_SUCCESS: 'GET_MATCHING_RULE_NAMES_SUCCESS',
    GET_RECON_EVENT_RULE_SUCCESS: 'GET_RECON_EVENT_RULE_SUCCESS',
};

export default actionTypes;